__webpack_require__.p = "/major_frontend/";